// extracted by mini-css-extract-plugin
export default {"container":"dt_g","title":"dt_cX","subtitle":"dt_jv","tickContainer":"dt_mj","tick":"dt_mk","container_active":"dt_ml","containerActive":"dt_ml"};